var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.text !== null)?_c('div',[_c('h5',{staticClass:"mb-3"},[_vm._v("Onde Comprar")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.text)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }